var React = require('react');

function HeartOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"nc-icon-wrapper","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"2","fill":"#111111","stroke":"#111111"},React.createElement("path",{"fill":"none","stroke":"#111111","strokeMiterlimit":"10","d":"M21.243,3.757 c-2.343-2.343-6.142-2.343-8.485,0c-0.289,0.289-0.54,0.6-0.757,0.927c-0.217-0.327-0.469-0.639-0.757-0.927 c-2.343-2.343-6.142-2.343-8.485,0c-2.343,2.343-2.343,6.142,0,8.485L12,21.485l9.243-9.243C23.586,9.899,23.586,6.1,21.243,3.757z"})));
}

HeartOutline.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 24 24","xmlSpace":"preserve","width":"24","height":"24"};

module.exports = HeartOutline;

HeartOutline.default = HeartOutline;
